import { createSlice } from "@reduxjs/toolkit";
import * as Actions from "../actions";
import {
  dataGruposDeAcessoReducer,
  dataMenusDeGrupoReducer,
} from "../reducers";
import { InitialStateGrupos } from "./models";

const initialState: InitialStateGrupos = {
  items: [],
  itemsMenusDeGrupo: {},
  dialogForm: {
    open: false,
    content: {
      mode: "",
      values: null,
    },
  },
  dialogAddMenu: {
    open: false,
    content: {
      mode: "",
      values: null,
    },
  },
  requestGetParams: {},
  pagination: {
    page: 1,
    rowsPerPage: 15,
    totalPages: 0,
    totalItems: 0,
  },
  requestGetParamsMenusDeGrupo: {},
  paginationMenusDeGrupo: {
    default: {
      pagination: {
        page: 1,
        rowsPerPage: 15,
        totalPages: 0,
        totalItems: 0,
      },
    },
  },
  allItemsMenu: [],
  allItemsApelidos: [],
};

const gruposDeAcessoSlice = createSlice({
  name: "acessosApp/gruposDeAcesso",
  initialState,
  reducers: {
    openDialogForm: (state, action) => {
      state.dialogForm = {
        open: true,
        content: action.payload,
      };
    },
    closeDialogForm: (state) => {
      state.dialogForm = {
        open: false,
        content: {
          mode: "",
          values: null,
        },
      };
    },
    openDialogAddMenu: (state, action) => {
      state.dialogAddMenu.open = true;
      state.dialogAddMenu.content = action.payload;
    },
    closeDialogAddMenu: (state) => {
      state.dialogAddMenu.open = false;
      state.dialogAddMenu.content = {
        mode: "",
        values: null,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      Actions.getGruposDeAcesso.fulfilled,
      dataGruposDeAcessoReducer
    );
    builder.addCase(Actions.getMenusDeGrupo.fulfilled, dataMenusDeGrupoReducer);
  },
});

export const {
  openDialogForm,
  closeDialogForm,
  openDialogAddMenu,
  closeDialogAddMenu,
} = gruposDeAcessoSlice.actions;

export default gruposDeAcessoSlice.reducer;
